<template>
  <div class="pdspecs">
    <div id="pdstt">{{$t('lang.prodspecs')}}</div>
    <div id="pdsfr">
      <div v-for="item in data.data" :key="item.label">
        <img :src="require('@/assets/pic/spec/'+item.pic)"/>
        <p>{{item.label}}</p>
        <label v-for="item1 in item.desc" :key="item1">{{item1}}</label>
      </div>
    </div>
    <label @click="clickDown" id="pdsbtn">{{$t('lang.datadownl')}}</label>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    data: Object
  },
  watch: {
    data (n) {
  
    }
  },
  data () {
    return {
      
    }
  },
  methods: {
    clickDown () {
      var pre = this.$store.state.iscn?'http://dl.szzt.com.cn/download/products/':'http://dl.szzt.com.cn/download/en/products/'
      var file = this.$store.state.iscn?this.data.file:this.data.file.toUpperCase()
      window.open(pre+file+'.pdf','_blank')
    }
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pdspecs {
  background-image: url('../assets/pic/pdsbg.png');
  background-size: 100% 100%;
  overflow: hidden;
  text-align: center;
}

#pdstt {
  font-size: .6rem;
  text-align: center;
  font-weight: bold;
  color: #FFFFFF;
  padding-top: .9rem;
  padding-bottom: 1.25rem;
}

#pdsbtn {
  display: inline-block;
  height: .7rem;
  background-image: url('../assets/pic/pdspbtn.png');
  background-size: 100% 100%;
  margin: .72rem auto 1.32rem auto;
  cursor: pointer;
  color: #FFFFFF;
  font-size: .24rem;
  font-weight: 400;
  line-height: .7rem;
  padding-left: 1.1rem;
  padding-right: .5rem;
}

#pdsfr {
  width: 15.35rem;
  margin: 0 auto;
  text-align: left;
  padding-left: 1.9rem;
  /* border: 1px solid red; */
}

#pdsfr div {
  width: 3.87rem;
  padding-right: 1.21rem;
  overflow: hidden;
  display: inline-block;
  margin-bottom: .86rem;
  vertical-align: top;
  /* border: 1px solid red; */
}
#pdsfr img {
  display: inline-block;
  width: .34rem;
  height: .34rem;
  vertical-align: top;
  margin-right: .2rem;
}
#pdsfr p {
  margin: -.05rem 0 .2rem 0;
  padding: 0;
  display: inline-block;
  vertical-align: top;
  font-size: .27rem;
  font-weight: 500;
  color: white;
}
#pdsfr label {
  display: block;
  margin-left: .54rem;
  font-size: .2rem;
  font-weight: 400;
  color: #F4F4F4;
  width: 3.53rem;
  margin-bottom: .05rem;
  /* border: 1px solid red; */
}

</style>
